import { render, staticRenderFns } from "./ConsentForm.vue?vue&type=template&id=1c6f2f6a&scoped=true"
import script from "./ConsentForm.vue?vue&type=script&lang=js"
export * from "./ConsentForm.vue?vue&type=script&lang=js"
import style0 from "./ConsentForm.vue?vue&type=style&index=0&id=1c6f2f6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f2f6a",
  null
  
)

export default component.exports